import { Stato } from "@/lib/stato";
import { CommonState } from "./common/state/models";
import { DetectionState } from "@/views/detection/data/models";
import { DetectionDrillDownState } from "./views/detection/detection-drilldown/data/models";
import { AccountsState } from "./views/accounts/data/models";
import { InvestigationState } from "./views/investigation/data/models";
import { AdminsState } from "./views/admins/data/models";

interface TheState {
  shared: CommonState;
  detection: DetectionState;
  detectionDrillDown: DetectionDrillDownState;
  investigation: InvestigationState;
  accounts: AccountsState;
  admins: AdminsState;
}

const { createState, addPlugin, attachRouter } = Stato<TheState>({});

export { createState, addPlugin, attachRouter };
